import React from 'react';

import { EntitySwitch, isComponentType } from '@backstage/plugin-catalog';

import {
  isAIToolComponent,
  isDaaSComponent,
  isJiraTeamComponent,
} from '../entityUtils';
import { AIToolsEntityPage } from './AIToolsEntityPage';
import { DaaSEntityPage } from './DaaSEntityPage';
import { DefaultEntityPage } from './DefaultEntityPage';
import { InfrastructureEntityPage } from './InfrastructureEntityPage';
import { JiraTeamPage } from './JiraTeamPage';
import { ServiceEntityPage } from './ServiceEntityPage';
import { WebsiteEntityPage } from './WebsiteEntityPage';

export const ComponentPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isComponentType('service')}>
      {ServiceEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('website')}>
      {WebsiteEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('infrastructure')}>
      {InfrastructureEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case if={isDaaSComponent}>{DaaSEntityPage}</EntitySwitch.Case>

    <EntitySwitch.Case if={isAIToolComponent}>
      {AIToolsEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case if={isJiraTeamComponent}>
      {JiraTeamPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case>{DefaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
